import React from 'react';
import { METRIC_CATALOG } from './constants';
import { Metric } from './types';

interface MetricsSectionProps {
  selectedMetrics: Metric[];
  onChange: (metrics: Metric[]) => void;
}

const CALIPER_METRICS = METRIC_CATALOG.filter((m) => m.source === 'caliper');
const ASSESSMENT_METRICS = METRIC_CATALOG.filter((m) => m.source === 'assessments');

const MetricsSection: React.FC<MetricsSectionProps> = ({ selectedMetrics, onChange }) => {
  const handleToggle = (id: Metric) => {
    if (selectedMetrics.includes(id)) {
      onChange(selectedMetrics.filter((m) => m !== id));
    } else {
      onChange([...selectedMetrics, id]);
    }
  };

  const renderGroup = (
    groupLabel: string,
    items: typeof CALIPER_METRICS | typeof ASSESSMENT_METRICS
  ) => (
    <div className="mb-4">
      <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">
        {groupLabel}
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {items.map((metric) => {
          const checked = selectedMetrics.includes(metric.id as Metric);
          return (
            <label
              key={metric.id}
              className="flex items-center gap-3 cursor-pointer group"
            >
              <input
                type="checkbox"
                checked={checked}
                onChange={() => handleToggle(metric.id as Metric)}
                className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
              />
              <span className="text-sm text-gray-800 group-hover:text-blue-700">
                {metric.label}
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );

  return (
    <div className="p-4 border border-gray-200 rounded-lg hover:border-blue-300 transition-colors">
      <h3 className="text-lg font-medium text-gray-800 mb-1">Metrics</h3>
      <p className="text-sm text-gray-500 mb-4">
        Select at least one metric to aggregate over the date range.
      </p>
      {renderGroup('From Caliper', CALIPER_METRICS)}
      {renderGroup('From Assessments', ASSESSMENT_METRICS)}
      {selectedMetrics.length === 0 && (
        <p className="text-xs text-red-500 mt-1">At least one metric is required.</p>
      )}
    </div>
  );
};

export default MetricsSection;
